import { render } from "./SponsorDtlPage.vue?vue&type=template&id=8e30c954"
import script from "./SponsorDtlPage.vue?vue&type=script&lang=js"
export * from "./SponsorDtlPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__